import {
  CircularProgress,
  IconButton,
  Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TableSortLabel
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { useState } from "react";
import { useHistory } from "react-router";
import { COACHEE_URL, COACH_URL, CONV_COACHEE_URL, CONV_COACH_URL, Framework, PD_COACHEE_URL, PD_COACH_URL, SessionType } from "../../config/Config";
import styles from "../../pages/sessions/sessionOverview/SessionsOverview.module.scss";
import { getLocalValue } from "../../utils/auth";
import { PaginationV2 } from "../Pagination/indexV2";
import { PerPage } from "../PerPage";

export default function SortableTableV2({
  columns,
  data,
  totalPages,
  loading,
  limit,
  setLimit,
  currentPage,
  handlePageClick,
  order,
  orderBy,
  onSort,
  expandable,
  renderExpandedContent,
  onRowClick
}) {
  const history = useHistory();

  const [openRow, setOpenRow] = useState(null);
  const [uid] = useState(getLocalValue("uid"));

  const handleSort = (columnId) => {
    if (!onSort) return;
    const nextOrder = orderBy === columnId && order === "asc" ? "desc" : "asc";
    onSort(columnId, nextOrder);
  };

  const toggleRow = (id) => {
    setOpenRow(prev => (prev === id ? null : id));
  };

  const colSpan = columns.length + (expandable ? 1 : 0);

  function getColumnStyle(col) {
    return {
      width: col.width,
      minWidth: col.minWidth,
      maxWidth: col.maxWidth,
      ...col.style,
    };
  }

  const renderBody = () => {
    if (loading) {
      return (
        <TableRow>
          <TableCell colSpan={colSpan} align="center" style={{ padding: "32px 0" }}>
            <CircularProgress size={24} />
          </TableCell>
        </TableRow>
      );
    }

    if (!data.length) {
      return (
        <TableRow>
          <TableCell colSpan={colSpan} align="center">
            No data
          </TableCell>
        </TableRow>
      );
    }

    return data.map((row, rowIndex) => {
      const rowId = rowIndex;
      const isOpen = openRow === rowId;
      return (
        <>
          <TableRow
            key={rowIndex}
            className={`${styles.tableRow} ${isOpen ? styles.openRow : ""}`}
            onClick={() => {
              if (!onRowClick) return;
              const url = window.location.pathname;
              if (url.includes("/logs")) {
                history.push(`/logs/archive-session/${row.id}`);
              } else {
                const isPDSession = row.framework === Framework.PD;
                const isConversationalSession =
                  row.session_type_id === SessionType.Conversational;
                const isCoachee = parseInt(uid) === row.coachee_id;
                let URL = "";
                if (isCoachee) {
                  if (isPDSession) {
                    URL = PD_COACHEE_URL;
                  } else if (isConversationalSession) {
                    URL = CONV_COACHEE_URL;
                  } else {
                    URL = COACHEE_URL;
                  }
                } else {
                  if (isPDSession) {
                    URL = PD_COACH_URL;
                  } else if (isConversationalSession) {
                    URL = CONV_COACH_URL;
                  } else {
                    URL = COACH_URL;
                  }
                }

                // DEV NOTE: Storing filter data in session storage to be used when returning back to overview page
                // const fData = {
                //   showFilter,
                //   selectedDateRange,
                //   selectedType,
                //   selectedSessionCoach,
                //   selectedSessionCoachee,
                //   selectedSubject,
                //   StatusFilterBy,
                //   CoachesFilterBy,
                // };
                // sessionStorage.setItem("sessionFilterData", JSON.stringify(fData));
                history.push(`${URL[row.status]}${row.session_id}`);
              }
            }}
          >
            {columns.map((col, index) => (
              <TableCell key={index} className={`${isOpen ? styles.openRow : ""}`} style={getColumnStyle(col)}>
                {col.render
                  ? col.render(row[col.id], row)
                  : row[col.id]}
              </TableCell>
            ))}

            {expandable && (
              <TableCell width={50} align="center">
                <IconButton
                  aria-label="expand row"
                  size="small"
                  style={{ outline: "none" }}
                  onClick={e => {
                    e.stopPropagation();
                    toggleRow(rowId);
                  }}
                >
                  {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
            )}
          </TableRow>

          {expandable && isOpen && (
            <TableRow className={styles.tableDetailsRow}>
              <TableCell
                style={{ padding: "0", borderBottomWidth: isOpen ? "1px" : 0 }}
                colSpan={colSpan ?? 7}
              >
                {renderExpandedContent(row)}
              </TableCell>
            </TableRow>
          )}
        </>
      )
    });
  }

  return (
    <>
      <TableContainer component={Paper} elevation={0}>
        <Table aria-label="Team" className={styles.table}>
          <TableHead className={styles.tableHead}>
            <TableRow>
              {columns.map((col, index) => (
                <TableCell key={index} align={col.align || "left"} style={getColumnStyle(col)}>
                  {col.sortable ? (
                    <TableSortLabel
                      active={orderBy === col.id}
                      direction={orderBy === col.id ? order : "asc"}
                      onClick={() => handleSort(col.id)}
                    >
                      {col.label}
                    </TableSortLabel>
                  ) : (
                    col.label
                  )}
                </TableCell>
              ))}
              {expandable && <TableCell />}
            </TableRow>
          </TableHead>

          <TableBody>
            {renderBody()}
          </TableBody>
        </Table>
      </TableContainer>

      <div className={styles.footer}>
        <PerPage limit={limit} setLimit={setLimit} />
        <PaginationV2
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageClick={handlePageClick}
        />
      </div>
    </>

  );
}
